import { motion } from "framer-motion";

export function FullScreenSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50">
      <motion.div
        className="size-6 rounded-full border-2 border-neutral-200 border-t-neutral-900"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 0.7, ease: "linear" }}
      />
    </div>
  );
}
